import SplitLine from './split.vue';
export default SplitLine;



// WEBPACK FOOTER //
// ./src/components/split/index.js